import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VueStore from "../../store/VueStore";
import router from "../../router";
import axios from "axios";
import moment from "moment";
import { signallampController } from "./scripts/signallamp_controller";
import { makeSignallampAlertHistoryData } from "./scripts/get_signallamp_threshold";
import {
  MstSignallampComponentType,
  MstSignallampSettingType,
  AuthStoreType,
  lampColorsType,
  LampColorAndFlagMapType,
  SignallampAlertHistoryRawDataType,
} from "../../types/types";
import { saveSignallampSetting } from "./scripts/save_signallamp_setting";
import graphContentConfig from "../graphContent/scripts/graph_content_config";
import SignallampContentConfig from "./scripts/signallamp_content_config";
import { RequestSignallampParamsMaker } from "./scripts/make_signallamp_request_params";
import { AuthStoreController } from "../../common/scripts/auth_store_controller";
import { SignallampStoreController } from "./scripts/signallamp_store_controller";
import {
  makeListDataSets,
  chartHistoryGraph,
} from "./scripts/chart_history_graph";
import { updateAndGetAndApplyComponentSetting } from "./scripts/update_and_get_and_apply_settings";
import { translate } from "@/main";

@Component({})
export default class SignalContent extends Vue {

  [key: string]: any;
  public token: string = VueStore.state.token;
  public userID: string = JSON.parse(localStorage.getItem("iotKyotoAuth")).userName;
  // マスター設定
  public mstSignallampComponent: MstSignallampComponentType;
  public mstSignallampSettings: MstSignallampSettingType[];
  public mstSignallampSetting: MstSignallampSettingType;
  public signallampStores: MstSignallampSettingType[];
  public signallampStoreSetting: boolean = false;
  public signallampStoreName: string = "";
  public addSignallampStore: boolean = true;
  // auth
  public authStoreProcessMsg: string = "";
  public authStores: AuthStoreType[] = [];
  public authStore: AuthStoreType; // TODO:名前
  public authStoreName: string = "";
  public addAuthStore: boolean = true;
  public addAuthStoreForm: boolean = false;
  public authStoreSetting: boolean = false;
  public closeAuthStoreForm: boolean = false;
  public selectedAuthStore: string = "";
  public newStoreName: string = "";
  // key
  public newAccessKey: string = "";
  public newSecretKey: string = "";
  // color
  public keyColors: string[] = [];
  public lampColors: lampColorsType[] = []; // TODO: 名前
  public lampColorAndFlagMap: LampColorAndFlagMapType[] = [];
  public lampColorTopToChooseFrom = SignallampContentConfig.lampColorItems();
  // time & date系
  public lastSendTime: string = "";
  public latestDataDate: string = `${translate("message.notAcquired")}`;
  public timeZone: string =
  typeof JSON.parse(localStorage.getItem("graphSettings")).useTimeZone ===
  "undefined"
    ? "+09:00"
    : JSON.parse(localStorage.getItem("graphSettings")).useTimeZone;
  // submit
  public submitButton: boolean = true;
  public submitWait: boolean = false;
  public submitComplete: boolean = false;
  // deviceID
  public deviceId: string = "";
  public deviceIds: string[] = [];
  public newDeviceId: string = "";
  public selectDeviceId: string = "";
  // table
  public dbTable: string = "";
  // alert
  public alertHistoryTitle: string = "";
  public useAlertSound: boolean = false;
  public backGroundAlertFlags: {[key: string]: boolean} = {red : false, yellow: false, blue: false, green: false, white: false};
  // センサーデータ送信エラーメッセージチェック
  public errorMassageFlag: boolean = false;
  public errorMassage: string = "";
  // content
  public signalContentArea: boolean = false;
  public signalContent: boolean = true;
  public optionContent: boolean = false;
  // history
  public historyTitle: string = "";
  public getHistoryData: any = []; // TODO: 名前
  // setting
  public settingIcon: boolean = true;
  public location: string = "--";
  public mails: string = "";
  public regionItems = graphContentConfig.regionItems();
  public newRegion: string = "ap-northeast-1";
  // graph
  public graphLoading: boolean = true;
  // signal
  public signallampID: number | null = null;
  public componentTitle: string = "";
  public signalArea: boolean = true;
  public noneFlash: boolean = false;
  // コンポーネント
  public addSignallampStoreForm: boolean = false;
  public closeSignallampStoreForm: boolean = false;
  public signallampStoreProcessMsg: string = "";
  // signallamp Store
  public addDeviceId: string = "";
  public newkeyColors: string[] = ["", "", "", ""];
  public alertCheck: boolean[] = [false, false, false, false];
  public addMails: string = "";
  public mailSendIntervalList = SignallampContentConfig.sendDurationList();
  public mailSendInterval: number = 10;
  public addDbTable: string = "";
  public addLocation: string = "";
  public formType: string = "";
  public reloadEvent: any = null;
  public errorCheck: boolean = false;

  @Prop() private signallampId!: string;
  @Watch("signallampId") public async onPropsChange(value: string, oldValue: string) {
    this.signallampId = value;
    await signallampController(this);
  }

  @Watch("addDeviceId") public updateDeviceId() {
    if (this.formType === "update") {
        this.matchSettingDataSets(this.addDeviceId);
    }
  }

  public matchSettingDataSets(addDeviceId: string) {
    const keyColors = [];
    const flags = [];
    for (const key in this.mstSignallampSettings) {
      const mstSignallampSettingData: any = this.mstSignallampSettings[key];
      if (addDeviceId === mstSignallampSettingData.device_id) {
        this.addMails = mstSignallampSettingData.mails.join(",");
        for (const lampColorAndFlag in mstSignallampSettingData.lamp_color_and_flag_map) {
          keyColors.push(mstSignallampSettingData.lamp_color_and_flag_map[lampColorAndFlag].color);
          flags.push(mstSignallampSettingData.lamp_color_and_flag_map[lampColorAndFlag].flag);
        }
        this.newkeyColors = keyColors;
        this.alertCheck = flags;
        this.mailSendInterval = mstSignallampSettingData.mail_send_interval;
        this.addDbTable = mstSignallampSettingData.table_name;
        if (!mstSignallampSettingData.location) {
          mstSignallampSettingData.location = "--";
        }
        this.addLocation = mstSignallampSettingData.location;
        this.authStoreName = mstSignallampSettingData.auth_store_name;
      }
    }
  }
  public async created() {
    this.signallampID = this.$props.signallampId;
    await signallampController(this);
    this.graphLoading = false;
    this.signalContentArea = true;
    this.$parent.$data.parentSignallampContentArea = true;
  }

  /**
   * 設定画面表示処理。
   */
  public changeSettingArea() {
    // パトランプ表示画面非表示
    this.signalContent = false;
    // 設定画面表示
    this.optionContent = true;
    this.selectDeviceId ? this.signallampStoreName = this.selectDeviceId : this.signallampStoreName = "";
    // 設定アイコン非表示
    this.settingIcon = false;
  }

  /**
   * 認証キー情報保存処理。
   * @returns {Promise<void>}
   */
  public async addSaveAuthStore() {
    const self = this;
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    await AuthStoreController.saveNew(self);
  }

  /**
   * signallampStore情報保存処理。
   * @returns {Promise<void>}
   */
  public async addSaveSignallampStore() {
    const self = this;
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    await SignallampStoreController.saveNewSignallampStore(self);
  }

  /**
   * AuthStore設定画面表示処理。
   */
  public displayAuthStoreArea() {
    this.signallampStoreSetting = !this.signallampStoreSetting;
    this.authStoreSetting = !this.authStoreSetting;
  }

  /**
   * パトランプ設定画面表示処理。
   */
  public displaySignallampStoreArea() {
    this.optionContent = !this.optionContent;
    this.signallampStoreSetting = !this.signallampStoreSetting;
    this.addSignallampStore = !this.addSignallampStore;
    this.closeSignallampStoreForm = !this.closeSignallampStoreForm;
    this.addSignallampStoreForm = !this.addSignallampStoreForm;
  }

  /**
   * ランプパネル表示処理。
   */
  public displaySignallampArea() {
    this.signalContent = true;
    this.optionContent = false;
    this.settingIcon = true;
  }

  /**
   * 設定画面のタブの開閉処理。
   * @param {string} tabName タブ名
   */
  public changeTab(tabName: string) {
    const signalContent = this;
    signalContent[`${tabName}LessShow`] = !signalContent[`${tabName}LessShow`];
    signalContent[`${tabName}MoreShow`] = !signalContent[`${tabName}MoreShow`];
    signalContent[`${tabName}SettingMoreShow`] = !signalContent[
      `${tabName}SettingMoreShow`
    ];
  }

  public async changeUseAlertSound() {
    this.useAlertSound = !this.useAlertSound;
    await updateAndGetAndApplyComponentSetting(this);
  }

  /**
   * キー追加時の画面項目表示制御処理。
   * @param {string} column 対象項目（デバイスID、認証キー）
   */
  public displayAddKey(column: string) {
    const self = this;
    switch (column) {
      case "authStores":
        self.addAuthStore = !self.addAuthStore;
        self.closeAuthStoreForm = !self.closeAuthStoreForm;
        self.addAuthStoreForm = !self.addAuthStoreForm;
        self.newStoreName = "";
        self.newAccessKey = "";
        self.newSecretKey = "";
        return;
      case "signallampStores":
        self.formType = "new";
        self.addDeviceId = "";
        self.addMails = "--";
        self.newkeyColors = [];
        self.alertCheck = [false, false, false, false];
        self.mailSendInterval = 10;
        self.addDbTable = "";
        self.addLocation = "--";
        self.authStoreName = "";
        self.displaySignallampStoreArea();
        return;
      case "signallampUpdateStores":
        self.formType = "update";
        if (this.signallampStoreName) {
          this.addDeviceId = this.signallampStoreName;
          this.matchSettingDataSets(this.addDeviceId);
        }
        self.displaySignallampStoreArea();
        return;
      default:
        return;
    }
  }

  /**
   * デバイスID、認証情報などのキー情報の削除処理。
   * @param {string} keyType キー種別
   */
  public removeKey(keyType: string): void {
    const self = this;
    switch (keyType) {
      case "deviceIds":
        if (self.signallampStoreName === "") {
          alert(self.$t("message.selectDeviceIdToDelete"));
          return;
        }
        if (self.signallampStoreName === self.selectDeviceId) {
          alert(self.$t("message.cantDeleteDeviceIdInUse"));
          return;
        }
        SignallampStoreController.remove(self);
        self.signallampStoreName = "";
        return;
      case "authStores":
        if (self.selectedAuthStore === "") {
          alert(self.$t("message.selectCredentialStoreToDelete"));
          return;
        }
        AuthStoreController.remove(self);
        this.selectedAuthStore = "";
        break;
      default:
        break;
    }
  }

  /**
   * デバイスIDなどキー情報の保存処理。
   * @param {string} keyType データ種別
   */
  public saveNewKey(keyType: string) {
    const self = this;
    switch (keyType) {
      case "deviceIds":
        if (self.newDeviceId !== "") {
          self.deviceIds.push(self.newDeviceId);
          self.newDeviceId = "";
        }
        break;
      default:
        break;
    }
  }
  public getIndex(textKey: string) {
    for (let i = 0; i < SignallampContentConfig.lampColorItems().length; i++) {
      if (SignallampContentConfig.lampColorItems()[i].text === textKey) {
        return SignallampContentConfig.lampColorItems()[i].value;
      }
    }
  }
  public async inquiryAlertHistory() {
    const indexComponent = this.$parent.$parent.$parent;
    indexComponent.$data.alertHistoryData = [];
    indexComponent.$data.alertHistoryArea = true;
    indexComponent.$data.overlayArea = true;
    indexComponent.$data.alertHistoryTitle = `${this.$t("message.alarmHistoryMax100Events")} - ${this.location}`;
    const reqParams = RequestSignallampParamsMaker.makeGetSignallampAlertParams(this);
    const result = await axios(reqParams);
    if (!result) {
      this.signalContent = false;
      this.optionContent = true;
      this.settingIcon = false;
      this.graphLoading = false;
    } else {
      let alertHistoryRawData: SignallampAlertHistoryRawDataType[] = null;
      if (!result.data.res.signallamp_alert_data) {
        alertHistoryRawData = [];
      } else {
        alertHistoryRawData = result.data.res.signallamp_alert_data.Items;
      }
      const alertLog = await makeSignallampAlertHistoryData(this, alertHistoryRawData);
      indexComponent.$data.alertHistoryData = alertLog;
    }
  }

  /**
   * 過去状況ボタン クリック処理。
   * @returns {Promise<void>}
   */
  public async inquiryHistory() {
    const indexComponent = this.$parent.$parent.$parent;
    indexComponent.$data.historyDatasets = [];
    indexComponent.$data.historyArea = true;
    indexComponent.$data.overlayArea = true;
    indexComponent.$data.historyTitle = `${this.$t("message.historyDataInLast8Hours")} - ${this.location}`;
    for (const key in this.authStores) {
      if (this.authStoreName === this.authStores[key].store_name) {
        const req: object = RequestSignallampParamsMaker.makeGetSignallampHistoryParams(
          this,
          this.userID,
          this.authStores[key],
          this.selectDeviceId,
        );
        const getHistory = await axios(req);
        this.getHistoryData = getHistory.data.res.signallamp_history;
        const toTime = moment().utc().format("YYYY-MM-DD HH:mm:ssZ");
        const fromTime = moment()
          .utc()
          .subtract(8, "hours")
          .format("YYYY-MM-DD HH:mm:ssZ");
        indexComponent.$data.historyDatasets = makeListDataSets(
          this.getHistoryData,
          this.keyColors,
          this
        );
        indexComponent.$data.ToTime = this.$t("message.currentTime");
        indexComponent.$data.FromTime = this.$t("message.8HoursAgo");
        indexComponent.$data.chart = chartHistoryGraph(
          this.getHistoryData,
          toTime,
          fromTime,
          this.keyColors
        );
      }
    }
  }

  /**
   * 設定画面保存ボタン押下処理
   * @returns {Promise<void>}
   */
  public async saveSetting() {
    const self = this;
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    self.selectDeviceId = self.signallampStoreName;
    await saveSignallampSetting(self);
  }
}
